// Global volume state management
// Ensures volume/mute state persists across all video types (YouTube, MP4 broadcast, streams)
const VOLUME_STORAGE_KEY = 'gridchat_global_volume';
const subscribers = new Set();
// Current volume state (0-100)
let currentVolume = loadVolumeFromStorage();
/**
 * Load volume from localStorage
 */
function loadVolumeFromStorage() {
    try {
        const stored = localStorage.getItem(VOLUME_STORAGE_KEY);
        if (stored !== null) {
            const volume = parseInt(stored, 10);
            if (!isNaN(volume) && volume >= 0 && volume <= 100) {
                console.log(`ðŸ”Š Loaded global volume from storage: ${volume}`);
                return volume;
            }
        }
    }
    catch (error) {
        console.warn('Failed to load volume from storage:', error);
    }
    // Default to muted (0)
    console.log('ðŸ”Š Using default volume: 0 (muted)');
    return 0;
}
/**
 * Save volume to localStorage
 */
function saveVolumeToStorage(volume) {
    try {
        localStorage.setItem(VOLUME_STORAGE_KEY, volume.toString());
    }
    catch (error) {
        console.warn('Failed to save volume to storage:', error);
    }
}
/**
 * Get current global volume
 */
export function getGlobalVolume() {
    return currentVolume;
}
/**
 * Set global volume and notify all subscribers
 */
export function setGlobalVolume(volume) {
    // Clamp volume to 0-100 range
    const clampedVolume = Math.max(0, Math.min(100, volume));
    if (clampedVolume !== currentVolume) {
        currentVolume = clampedVolume;
        saveVolumeToStorage(clampedVolume);
        console.log(`ðŸ”Š Global volume updated: ${clampedVolume}`);
        // Notify all subscribers
        subscribers.forEach(callback => {
            try {
                callback(clampedVolume);
            }
            catch (error) {
                console.error('Error in volume subscriber:', error);
            }
        });
    }
}
/**
 * Subscribe to volume changes
 * Returns unsubscribe function
 */
export function subscribeToVolume(callback) {
    subscribers.add(callback);
    // Immediately call with current volume
    callback(currentVolume);
    // Return unsubscribe function
    return () => {
        subscribers.delete(callback);
    };
}
/**
 * Check if currently muted
 */
export function isGloballyMuted() {
    return currentVolume === 0;
}
/**
 * Toggle mute state
 * If muted, restore to 50%, otherwise mute to 0
 */
export function toggleGlobalMute() {
    if (currentVolume === 0) {
        // Unmute to 50%
        setGlobalVolume(50);
    }
    else {
        // Mute
        setGlobalVolume(0);
    }
}
